import './tailwind.css';
export * from './components/PptEditor';
export * from './lib/pptx-parser';
export * from './lib/pptx-exporter';
export * from './lib/PptxBlobExporter';
export * from './lib/types';
